import { createSlice } from "@reduxjs/toolkit";
import { getallapasscode_thunk } from "./PasscodeManager.Thunk";

const initialState = {
  data: [],
  loading: false,
  status: "",
  message: "",
};

const PasscodeManagerSlice = createSlice({
  name: "passcodemanagerslice",
  initialState,
  reducers: {},
  extraReducers: {
    [getallapasscode_thunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getallapasscode_thunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getallapasscode_thunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export default PasscodeManagerSlice.reducer;
